<template>
  <b-container class="wrap-winner">
    <div
      v-for="winner in winners"
      v-show="winner.files.length !== 0"
      :key="winner.id"
      class="wrap-content"
    >
      <h1>{{ winner.winnertitle }}</h1>
      <img :src="winner.imgUrl">
      <b-row class="box-btn">
        <b-col
          v-for="(file, i) in winner.files"
          :key="i"
          cols="12"
          md="6"
        >
          <a :href="file.url" target="_black" v-if="file.url">
            <div
              v-b-tooltip.hover.bottom
              :title="file.tooltip"
            >
              {{ file.title }}
            </div>
          </a>
        </b-col>
      </b-row>
    </div>
  </b-container>
</template>

<script>
import { mapState } from 'vuex'
import { constantsComputed } from '@/store/helpers'

export default {
  data () {
    return {
      winners: []
    }
  },

  computed: {
    ...constantsComputed,
    ...mapState({
      winnersRaw: state => state.winners.winners
    })
  },

  methods: {
    matchBtn (data) {
      if (data) {
        data.forEach(winner => {
          const obj = {
            id: winner.id,
            winnertitle: winner.winner_title,
            publish_datetime_1: winner.publish_datetime_1,
            publish_datetime_2: winner.publish_datetime_2,
            end_datetime_1: winner.end_datetime_1,
            end_datetime_2: winner.end_datetime_2,
            imgUrl: `${this.baseURL}/storage/app/img/winner/${winner.image}`,
            files: [
              {
                title: winner.title_pdf1,
                url: `${this.baseURL}/storage/app/pdf/winner/${winner.pdf_1}`
              },
              {
                title: winner.title_pdf2,
                url: `${this.baseURL}/storage/app/pdf/winner/${winner.pdf_2}`
              },
              {
                title: winner.title_pdf3,
                url: `${this.baseURL}/storage/app/pdf/winner/${winner.pdf_3}`
              },
              {
                title: winner.title_pdf4,
                url: `${this.baseURL}/storage/app/pdf/winner/${winner.pdf_4}`
              }

            ]
          }
          const files = obj.files.filter((file) => file.title && file.url)
          Object.assign(obj, { files: files })
          this.winners.push(obj)
        })
      }
    }
  },

  created () {
    if (!this.winnersRaw) {
      this.$store.dispatch('winners/get')
    }

    this.matchBtn(this.winnersRaw)
  },

  watch: {
    winnersRaw (data) {
      this.matchBtn(data)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

.wrap-winner {
  .wrap-content {
    h1 {
      padding: 22px 0;
      text-align: center;
      font-size: 1.75rem;
    }

    img {
      width: 100%;
      height: 100%;
      background-color: $light;
    }

    .row {
    justify-content: center;
    }

    .box-btn {
      padding: 11px 0;

      a {
        div {
          margin: 11px 0;
          padding: 12px 0;
          width: 100%;
          background-color: #C4C5C5;
          border-bottom: 3px solid #58595B;
          text-align: center;
          font-size: 1.25rem;
          color: black;
        }
      }
    }
  }
}
</style>
